import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function HeroVideo() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll();
  const scale = useTransform(scrollYProgress, [0, 0.3], [1.05, 1.18]);

  return (
    <motion.div ref={ref} className="absolute inset-0 overflow-hidden" style={{ scale }} data-testid="hero-video">
      <motion.video
        className="w-full h-full object-cover"
        src="/hero_web.mp4"
        poster="/hero_poster.jpg"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
      />
    </motion.div>
  );
}
